import * as angular from "angular";
import {IController} from "angular";
import {AccountCommissionSummaryModel} from "../../models/accountCommissionSummary.model";

export class SupplyAccountsCommissionSummaryTableRowCtrl implements IController {

  accountSummary: AccountCommissionSummaryModel;

  constructor() {
  }

  $onInit() {

  }

  $onChanges(changes) {

  }

}

angular
  .module('bringoz.admin.accounts')
  .component('supplyAccountsCommissionsSummaryTableRow', {
    bindings: {
      accountSummary: '<'
    },
    template: require('./supply-accounts-commissions-summary-table-row.html').default,
    controller: SupplyAccountsCommissionSummaryTableRowCtrl
  });
